module.exports = __webpack_public_path__ + "img/b2d4b6babc651e696e705e154dad4969.3fdd2f11.png";